var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41382 0.647107C8.88486 1.1518 8.85759 1.94278 8.3529 2.41382C6.57861 4.07496 4.80357 5.81652 3.32137 7.75001L18.7499 7.75001C19.4402 7.75001 20 8.30965 20 9.00001C20 9.69036 19.4393 10.25 18.7489 10.25L3.32136 10.25C4.80425 12.1844 6.57486 13.9215 8.3529 15.5862C8.85759 16.0572 8.88486 16.8482 8.41382 17.3529C7.94278 17.8576 7.15159 17.8847 6.6469 17.4136C4.71459 15.6093 2.81663 13.7451 1.22656 11.625C0.669005 10.8816 -4.24978e-07 9.97237 -3.82475e-07 9C-3.39971e-07 8.02764 0.669005 7.11841 1.22656 6.375C2.80707 4.26766 4.73187 2.3847 6.6471 0.586186C7.15179 0.115143 7.94278 0.142419 8.41382 0.647107Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWhiteArrow);
export default __webpack_public_path__ + "static/media/mobileWhiteArrow.695b2b67a5566aa1bb052c08d21628f4.svg";
export { ForwardRef as ReactComponent };